import { useStyletron } from 'baseui';
import { ROOM_USAGE } from './types';

export const RoomIcon = (props: { height?, width?, color, usage?: ROOM_USAGE }) => {
    if ( !props.usage )
        return <IconDefault {...props}></IconDefault>
    switch (props.usage) {
        case ROOM_USAGE.Corridor:
            return <IconCorridor {...props}></IconCorridor>
        case ROOM_USAGE.Kitchen:
            return <IconKitchen {...props}></IconKitchen>
        case ROOM_USAGE.Office:
            return <IconWorkspace {...props}></IconWorkspace>
        default:
            return <IconDefault {...props}></IconDefault>
    }
}
const IconDefault = (props: { height?, width?, color }) => {
    return (
        <svg width={props.width ?? '100%'} height={props.height ?? '100%'} viewBox="0 0 68 44" version="1.1" x="0px" y="0px">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g transform="translate(-416.000000, -308.000000)" fillRule="nonzero">
                <path fill={props.color} d="M420,308 L480,308 C482.209139,308 484,309.790861 484,312 L484,348 C484,350.209139 482.209139,352 480,352 L420,352 C417.790861,352 416,350.209139 416,348 L416,312 C416,309.790861 417.790861,308 420,308 Z M459,348 L459,342 L449,342 L449,348 L459,348 Z M463,348 L480,348 L480,312 L456,312 L456,316.341411 C458.330385,317.165084 460,319.387562 460,322 L460,325 C460,326.104569 459.104569,327 458,327 L450,327 C448.895431,327 448,326.104569 448,325 L448,322 C448,319.387562 449.669615,317.165084 452,316.341411 L452,312 L432,312 L432,348 L445,348 L445,342 L444,342 C442.895431,342 442,341.104569 442,340 C442,338.895431 442.895431,338 444,338 L464,338 C465.104569,338 466,338.895431 466,340 C466,341.104569 465.104569,342 464,342 L463,342 L463,348 Z M420,340 L423,340 C424.104569,340 425,340.895431 425,342 C425,343.104569 424.104569,344 423,344 L420,344 L420,348 L428,348 L428,312 L420,312 L420,316 L421,316 C422.104569,316 423,316.895431 423,318 C423,319.104569 422.104569,320 421,320 L420,320 L420,324 L423,324 C424.104569,324 425,324.895431 425,326 C425,327.104569 424.104569,328 423,328 L420,328 L420,332 L421,332 C422.104569,332 423,332.895431 423,334 C423,335.104569 422.104569,336 421,336 L420,336 L420,340 Z M456,323 L456,322 C456,320.895431 455.104569,320 454,320 C452.895431,320 452,320.895431 452,322 L452,323 L456,323 Z"></path>
            </g>
            </g>
        </svg>
    );
}

const IconCorridor = (props: { height?, width?, color }) => {
    return <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? '100%'} height={props.height ?? '100%'} viewBox="0 0 460.000000 492.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,492.000000) scale(0.100000,-0.100000)"
            fill={props.color} stroke="none">
            <path d="M65 4835 c-28 -28 -31 -54 -11 -93 8 -15 278 -290 600 -612 l586
-585 0 -1165 0 -1165 -520 -520 c-369 -369 -520 -527 -520 -542 0 -53 40 -93
93 -93 15 0 173 151 542 520 l520 520 925 0 925 0 505 -506 c278 -278 517
-512 532 -520 39 -20 65 -17 93 11 46 45 35 77 -55 169 l-80 82 0 1558 0 1557
-25 24 c-50 51 -58 46 -376 -226 -162 -138 -299 -261 -306 -273 -9 -16 -12
-245 -13 -971 l0 -950 -80 80 -80 80 0 1165 0 1165 600 600 c549 549 600 603
600 633 0 38 -37 82 -70 82 -12 0 -33 -6 -48 -14 -15 -8 -290 -278 -612 -600
l-585 -586 -925 0 -925 0 -600 600 c-549 549 -603 600 -633 600 -22 0 -41 -8
-57 -25z m3095 -2455 l0 -1120 -160 0 -160 0 0 895 0 896 -25 24 -24 25 -511
0 -511 0 -24 -25 -25 -24 0 -896 0 -895 -160 0 -160 0 0 1120 0 1120 880 0
880 0 0 -1120z m880 -512 l0 -1373 -200 200 -200 200 0 1005 1 1005 196 168
c108 92 198 167 200 167 2 0 3 -618 3 -1372z m-1360 232 l0 -840 -400 0 -400
0 0 840 0 840 400 0 400 0 0 -840z"/>
            <path d="M2465 2115 c-50 -49 -15 -135 55 -135 19 0 40 9 55 25 16 15 25 36
25 55 0 19 -9 40 -25 55 -15 16 -36 25 -55 25 -19 0 -40 -9 -55 -25z"/>
            <path d="M2225 4755 c-23 -22 -25 -31 -25 -128 l0 -105 -30 -12 c-68 -28 -130
-129 -130 -210 0 -124 116 -240 240 -240 124 0 240 116 240 240 0 81 -62 182
-130 210 l-30 12 0 105 c0 97 -2 106 -25 128 -15 16 -36 25 -55 25 -19 0 -40
-9 -55 -25z m110 -400 c50 -49 15 -135 -55 -135 -41 0 -80 39 -80 80 0 41 39
80 80 80 19 0 40 -9 55 -25z"/>
            <path d="M850 1617 c-36 -19 -195 -100 -354 -182 -159 -81 -297 -156 -307
-166 -18 -18 -19 -40 -19 -387 l0 -369 22 -20 c31 -27 54 -34 81 -24 30 12
708 636 725 668 10 18 12 77 10 243 -3 204 -4 221 -23 239 -36 35 -65 35 -135
-2z m0 -299 l0 -113 -202 -185 c-110 -102 -227 -209 -260 -239 l-58 -53 2 222
3 222 250 129 c138 71 253 129 258 129 4 0 7 -51 7 -112z"/>
        </g>
    </svg>

}

const IconKitchen = (props: { height?, width?, color }) => {
    return <svg width={props.width ?? '100%'} height={props.height ?? '100%'} viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={props.color} stroke="none">
            <path d="M1237 5109 c-35 -21 -47 -71 -47 -204 l0 -125 -49 0 c-34 0 -57 -7
-79 -22 -38 -28 -858 -1010 -879 -1054 -21 -43 -7 -84 38 -107 32 -16 111 -17
1332 -15 l1299 3 24 28 c30 35 31 76 2 113 -13 16 -212 257 -444 535 -272 326
-430 508 -445 512 -13 4 -43 7 -66 7 l-42 0 -3 146 c-3 146 -3 146 -31 170
l-28 24 -282 0 c-182 -1 -289 -4 -300 -11z m473 -244 l0 -85 -170 0 -170 0 0
85 0 85 170 0 170 0 0 -85z m567 -680 c193 -231 352 -423 352 -427 1 -5 -490
-8 -1090 -8 -950 0 -1090 2 -1086 15 4 8 162 201 352 430 l347 415 386 -2 387
-3 352 -420z"/>
            <path d="M3103 3986 l-28 -24 -3 -1041 -2 -1041 -210 0 -210 0 0 40 0 40 40 0
c60 0 108 23 117 57 10 39 5 64 -20 91 l-20 22 -461 0 c-501 -1 -486 1 -507
-58 -22 -63 32 -112 122 -112 39 0 39 0 39 -40 l0 -40 -425 0 -425 0 0 40 0
40 48 0 c56 0 91 16 111 51 17 30 9 71 -19 99 -19 19 -35 20 -480 20 l-461 0
-24 -25 c-34 -33 -34 -83 0 -115 19 -18 40 -25 85 -28 l60 -4 0 -39 0 -38
-191 -3 -191 -3 -24 -28 -24 -28 0 -880 0 -881 29 -29 29 -29 2502 0 2502 0
29 29 29 29 0 1947 0 1947 -29 29 -29 29 -966 0 -965 0 -28 -24z m1847 -741
l0 -595 -855 0 -855 0 0 595 0 595 855 0 855 0 0 -595z m0 -1925 l0 -1150
-855 0 -855 0 0 1150 0 1150 855 0 855 0 0 -1150z m-4010 600 l0 -40 -170 0
-170 0 0 40 0 40 170 0 170 0 0 -40z m1530 0 l0 -40 -170 0 -170 0 0 40 0 40
170 0 170 0 0 -40z m-1102 -382 l2 -168 -600 0 -600 0 0 170 0 170 598 -2 597
-3 3 -167z m1702 -598 l0 -770 -765 0 -765 0 0 770 0 770 765 0 765 0 0 -770z
m-1702 -257 l-3 -508 -597 -3 -598 -2 0 510 0 510 600 0 600 0 -2 -507z"/>
            <path d="M3355 3215 c-25 -24 -25 -25 -25 -228 0 -190 1 -205 20 -225 41 -44
110 -35 137 18 17 33 18 382 1 413 -28 53 -92 64 -133 22z"/>
            <path d="M3375 2378 c-42 -25 -44 -35 -45 -246 0 -202 0 -203 25 -227 45 -46
125 -24 141 38 3 13 4 107 2 210 -3 171 -5 188 -23 207 -25 25 -74 34 -100 18z"/>
            <path d="M1775 1533 c-11 -3 -30 -14 -42 -26 l-23 -20 0 -547 c0 -535 0 -547
20 -568 11 -12 31 -24 43 -27 12 -3 260 -4 550 -3 l529 3 24 28 24 28 0 539 0
539 -24 28 -24 28 -529 2 c-290 0 -537 -1 -548 -4z m955 -593 l0 -430 -425 0
-425 0 0 430 0 430 425 0 425 0 0 -430z"/>
        </g>
    </svg>

}

const IconWorkspace = (props: { height?, width?, color }) => {
    return (<svg
        width={props.width ?? '100%'} height={props.height ?? '100%'} viewBox="0 0 530.000000 470.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,470.000000) scale(0.100000,-0.100000)"
            fill={props.color} stroke="none">
            <path d="M345 4591 c-47 -22 -89 -64 -104 -104 -7 -19 -11 -239 -11 -663 0
-610 1 -636 20 -673 24 -48 70 -87 118 -101 21 -6 156 -10 320 -10 l282 0 0
-29 c0 -25 -4 -29 -37 -35 -92 -14 -157 -97 -157 -198 l1 -58 -280 0 c-260 0
-284 -1 -322 -20 -26 -13 -49 -34 -63 -59 -21 -36 -22 -51 -22 -252 0 -194 2
-217 20 -246 10 -18 31 -39 45 -49 l25 -16 0 -984 c0 -971 0 -984 20 -1004 19
-19 33 -20 218 -20 108 0 202 4 208 8 33 22 34 47 34 846 l0 796 434 0 434 0
6 -44 c8 -50 38 -99 79 -130 28 -20 41 -21 408 -24 l379 -3 0 -203 c0 -177 2
-205 17 -217 9 -8 48 -15 95 -18 l78 -3 0 -123 0 -124 -52 -5 c-29 -3 -84 -8
-121 -12 -94 -8 -261 -47 -343 -80 -97 -38 -174 -91 -209 -145 -21 -31 -43
-51 -72 -63 -59 -25 -109 -84 -128 -151 -67 -228 206 -401 386 -246 55 46 79
100 79 179 0 97 -40 170 -114 209 l-30 16 25 20 c81 67 269 119 512 142 l67 7
0 -80 c0 -75 -1 -80 -23 -86 -47 -11 -104 -64 -132 -120 -55 -112 -17 -245 89
-311 44 -27 58 -30 126 -30 68 0 82 3 126 30 106 66 144 199 89 311 -28 56
-85 109 -132 120 -22 6 -23 11 -23 86 l0 80 68 -7 c242 -23 430 -75 511 -142
l25 -20 -30 -16 c-74 -39 -114 -112 -114 -209 0 -79 24 -133 79 -179 120 -103
300 -67 374 75 29 57 29 156 -1 212 -25 50 -93 110 -132 119 -19 4 -32 16 -40
36 -7 16 -33 48 -58 69 -110 98 -313 159 -614 186 l-68 6 0 124 0 124 73 0
c121 0 117 -7 117 236 l0 204 364 0 c233 0 375 4 393 11 53 20 92 68 105 131
l12 58 433 0 433 0 0 -805 c0 -792 0 -805 20 -825 19 -19 33 -20 220 -20 187
0 201 1 220 20 20 20 20 33 20 1004 l0 984 25 16 c14 10 35 31 45 49 18 29 20
52 20 246 0 202 -1 215 -22 253 -16 27 -36 45 -70 61 l-48 22 0 501 c0 473 -1
502 -18 517 -17 16 -86 17 -780 17 -719 0 -762 1 -762 18 0 30 -46 116 -81
151 -72 73 -50 71 -666 71 l-551 0 -4 233 c-3 224 -4 233 -27 274 -14 24 -42
55 -64 70 l-40 28 -846 2 c-807 3 -848 2 -886 -16z m1711 -132 c17 -19 19 -41
22 -240 l3 -219 -48 0 c-90 -1 -175 -60 -219 -155 -23 -49 -24 -56 -24 -362
l0 -313 -686 0 c-687 0 -714 1 -736 34 -4 6 -8 289 -8 628 l0 617 22 15 c20
14 116 16 839 16 l816 0 19 -21z m1262 -607 c65 -47 62 1 62 -890 l0 -809 -23
-34 c-47 -72 -21 -69 -707 -69 -686 0 -660 -3 -707 69 l-23 34 0 809 c0 883
-3 843 57 886 16 11 39 22 53 25 14 2 302 4 640 3 l615 -1 33 -23z m1622 -327
l0 -105 -715 0 -715 0 0 105 0 105 715 0 715 0 0 -105z m0 -350 l0 -115 -715
0 -715 0 0 115 0 115 715 0 715 0 0 -115z m-3610 -165 l0 -30 -115 0 -115 0 0
30 0 30 115 0 115 0 0 -30z m460 -130 l0 -160 -70 0 -70 0 6 38 c8 50 -10 113
-43 153 -29 34 -94 68 -130 69 -19 0 -23 6 -23 30 l0 30 165 0 165 0 0 -160z
m3150 -55 l0 -105 -715 0 -715 0 0 105 0 105 715 0 715 0 0 -105z m-3431 -1
c27 -34 26 -50 -4 -79 l-24 -25 -266 0 -266 0 -24 25 c-14 13 -25 31 -25 40 0
9 11 27 25 40 l24 25 270 0 270 0 20 -26z m281 -369 l0 -135 -66 0 c-85 0
-129 -21 -163 -77 l-26 -42 -655 2 -655 2 -3 180 c-1 98 0 185 2 192 4 10 160
13 786 13 l780 0 0 -135z m3285 -60 l0 -190 -655 -2 -655 -2 -26 42 c-34 56
-78 77 -163 77 l-66 0 0 135 0 135 783 -2 782 -3 0 -190z m-3285 -228 c0 -40
29 -111 61 -150 17 -21 54 -50 83 -65 l51 -27 665 0 665 0 54 30 c29 16 66 45
82 64 30 37 59 109 59 148 0 21 4 23 55 23 43 0 56 -4 65 -19 6 -12 10 -111
10 -251 0 -140 -4 -239 -10 -251 -10 -19 -32 -19 -980 -19 -948 0 -970 0 -980
19 -14 26 -14 476 0 502 9 15 22 19 65 19 51 0 55 -2 55 -23z m-260 -207 l0
-110 -482 0 c-434 0 -483 -2 -500 -17 -17 -15 -18 -54 -18 -825 l0 -808 -110
0 -110 0 0 935 0 935 610 0 610 0 0 -110z m3460 -825 l0 -935 -110 0 -110 0 0
807 c0 736 -1 808 -17 825 -15 17 -44 18 -500 18 l-483 0 0 110 0 110 610 0
610 0 0 -935z m-2220 230 l0 -155 -120 0 -120 0 0 155 0 155 120 0 120 0 0
-155z m-797 -985 c40 -45 38 -101 -7 -146 -24 -24 -43 -34 -66 -34 -68 0 -129
68 -115 130 4 16 23 43 42 61 32 27 41 31 77 26 29 -4 49 -15 69 -37z m727 25
c32 -17 60 -61 60 -95 0 -53 -57 -110 -110 -110 -53 0 -110 57 -110 110 0 33
28 78 58 94 35 20 66 20 102 1z m774 -15 c19 -17 37 -44 41 -60 14 -62 -47
-130 -115 -130 -23 0 -42 10 -66 34 -99 99 35 248 140 156z"  />
        </g>
    </svg>)
}